import React, { useCallback, useEffect } from "react";
import styled from "styled-components";
import { ClearButton } from "./styles";

const OuterContainer = styled.div`
  position: fixed;
  top: 50px;
  padding: 4px;
  z-index: 3;
  width: calc(100% - 80px);
  left: 33px;
  border: 3px solid #e04778;
  border-radius: 20px;
  background-color: #fff;

  @media only screen and (min-width: 975px) {
    top: 140px;
    width: 600px;
    left: calc(50% - 300px);
  }
`;

const Container = styled.div`
  background-color: #f2a7bf;
  border-radius: 16px;
  color: #fff;
  padding: 20px;
  width: calc(100% - 40px);

  @media only screen and (min-width: 975px) {
    padding: 40px;
    width: calc(100% - 80px);
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;

  @media only screen and (min-width: 975px) {
    justify-content: end;
  }
`;

const CloseButtonContainer = styled.div`
  display: flex;
  position: absolute;
  top: 20px;
  right: 40px;
  border-radius: 50px;
  height: 27px;
  width: 27px;
  cursor: pointer;

  &:hover {
    background-color: rgb(255, 216, 229);

    & div {
      color: #e04778;
    }
  }
`;

const CloseButton = styled.div`
  color: #fff;
  font-size: 26px;
  align-self: start;
  margin-top: -2.5px;
  margin-left: 6px;
`;

const Heading = styled.h1`
  font-size: 32px;
  text-align: center;
  color: #fff;
  margin-top: 0;
  margin-bottom: 12px;
`;

const InnerContainer = styled.div`
  background-color: rgb(255, 216, 229);
  margin: 0 auto;
  border-radius: 12px;
  border: none;
  padding: 20px;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 26px;
  color: #666;
  max-height: 320px;
  overflow-y: scroll;

  div:not(:last-child) {
    margin-bottom: 24px;
  }

  a {
    color: #e04778;
  }
`;

const PromptAvatarModal = ({ closeModal }) => {
  const handleClick = useCallback(
    (event) => {
      event.stopPropagation();
      const shouldClose = ![
        "prompt-avatar-modal",
        "prompt-avatar-modal-container",
        "prompt-avatar-modal-heading",
        "prompt-avatar-modal-inner-container",
        "prompt-avatar-modal-div",
        "prompt-avatar-modal-div-two",
        "prompt-avatar-modal-btns-container",
        "prompt-avatar-modal-user-avatar",
        "approve-modal-no-thanks",
        "approve-modal-close-container",
        "approve-modal-close",
      ].includes(event.target.id);
      if (shouldClose) {
        closeModal();
      }
    },
    [closeModal]
  );

  useEffect(() => {
    const body = document.querySelector("body");
    body.addEventListener("click", handleClick);
    return () => {
      body.removeEventListener("click", handleClick);
    };
  }, [handleClick]);

  return (
    <OuterContainer id="prompt-avatar-modal">
      <Container id="prompt-avatar-modal-container">
        <CloseButtonContainer onClick={closeModal}>
          <CloseButton>×</CloseButton>
        </CloseButtonContainer>
        <Heading id="prompt-avatar-modal-heading">FYI</Heading>
        <InnerContainer id="prompt-avatar-modal-inner-container">
          <div id="prompt-avatar-modal-div">
            If you want to manage your contract approvals later on, click the
            avatar image next to your ethereum address:
          </div>
          <div id="prompt-avatar-modal-div-two" style={{ textAlign: "center" }}>
            <img
              src="/user-icon.png"
              alt="user avatar"
              width="80px"
              id="prompt-avatar-modal-user-avatar"
              style={{ margin: "0 auto" }}
            />
          </div>
        </InnerContainer>
        <ButtonsContainer id="prompt-avatar-modal-btns-container">
          <ClearButton onClick={closeModal} noMargin>
            Got It
          </ClearButton>
        </ButtonsContainer>
      </Container>
    </OuterContainer>
  );
};

export default PromptAvatarModal;
